// extracted by mini-css-extract-plugin
module.exports = {"componentsNoticeBar":"styles_componentsNoticeBar__1c5gi"};